import React, {useEffect, useState} from 'react';
import fruitsfamilyLogo from "./assets/rounded_logo.svg";
import iconStar from "./assets/ic_yellow_star.svg";
import bgQRBorder from "./assets/bg_qr_border.svg";
import googleStoreBadge from "./assets/google_store_download_badge.svg";
import appStoreBadge from "./assets/app_store_download_badge.svg";
import PropTypes from "prop-types";
import {useAppInstallOneLinkUrl, useAppStoreUrl, useGooglePlayUrl} from "../../hook/appUrl";
import QRCode from 'qrcode';
import popupClose from "./assets/popup_close.svg";
import {useAppInstallModal} from "../../store/useAppInstallModal";
import {logWebToApp} from "../../util/analytics";

/**
 * 앱설치 유도 팝업 PC 버전
 * @param text
 * @returns {Element}
 * @constructor
 */
export default function AppInstallModalPc({ text }) {
    const { closeModal, source } = useAppInstallModal();
    const appStoreUrl = useAppStoreUrl();
    const googlePlayUrl = useGooglePlayUrl();
    const oneLinkUrl = useAppInstallOneLinkUrl();
    const [qrSvg, setQrSvg] = useState('');
    const handleOnClickStore = () => logWebToApp('web_to_app_cta_click', source);

    useEffect(() => {
        QRCode.toString(oneLinkUrl, { type: 'svg' })
            .then(setQrSvg)
            .catch(console.error);
    }, [oneLinkUrl]);

    return <div className='AppInstallModal-Pc-content'>
        <button type="button" onClick={closeModal} className="PopupClose" aria-label="닫기">
            <img src={popupClose} alt='' className="PopupCloseImage" />
        </button>
        <div className='Title'>{text || `앱에서 후루츠를\n제대로 즐겨보세요!`}</div>
        <div className='QRBackground'>
            <img src={bgQRBorder} alt="qr-border" className="QRBorder"/>
            {qrSvg && (
                <div
                    className="QR"
                    role="img"
                    aria-label="앱 다운로드 QR 코드"
                    dangerouslySetInnerHTML={{ __html: qrSvg }}
                />)
            }
        </div>
        <div className="AppstoreContainer">
            <img className="Logo" alt="FruitsFamily™ Logo" src={fruitsfamilyLogo}/>
            <div className="Appstore">
                <div className="Text">App Store 평점</div>
                <div className="StoreRating">
                    <div>4.9</div>
                    <div className="StoreRatingImages">
                        <div>
                            <img src={iconStar} alt="yellow-star" className="StoreRatingStar"/>
                            <img src={iconStar} alt="yellow-star" className="StoreRatingStar"/>
                            <img src={iconStar} alt="yellow-star" className="StoreRatingStar"/>
                            <img src={iconStar} alt="yellow-star" className="StoreRatingStar"/>
                            <img src={iconStar} alt="yellow-star" className="StoreRatingStar"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="Footer">
            <a className="DownLoadLink"
               href={appStoreUrl}
               rel="noopener noreferrer"
               target="_blank"
               onClick={handleOnClickStore}>
                <img src={appStoreBadge} alt="App Store에서 다운로드 하기"/>
            </a>
            <a className="DownLoadLink"
               href={googlePlayUrl}
               rel="noopener noreferrer"
               target="_blank"
               onClick={handleOnClickStore}>
                <img src={googleStoreBadge} alt="Play Store에서 다운로드 하기"/>
            </a>
        </div>
    </div>
}

AppInstallModalPc.propTypes = {
    text: PropTypes.string
}
